// Slide CTA buttons into place as they scroll into view.
const SELECTOR = 'main .btn, main .wp-block-button';
const STAGGER_MS = 120;

export default function revealCtas() {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  // Skip slider buttons; a scroll reveal fights the carousel's own movement.
  const ctas = [...document.querySelectorAll(SELECTOR)].filter((el) => !el.closest('.swiper'));

  if (!ctas.length) {
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries
      .filter((entry) => entry.isIntersecting)
      .forEach((entry, index) => {
        const cta = entry.target;

        // Stagger CTAs that enter together (e.g. a row of cards).
        cta.style.transitionDelay = `${index * STAGGER_MS}ms`;
        cta.classList.add('is-revealed');
        cta.addEventListener('transitionend', () => cta.style.removeProperty('transition-delay'), { once: true });
        observer.unobserve(cta);
      });
  }, { rootMargin: '0px 0px -10% 0px' });

  ctas.forEach((cta) => {
    cta.classList.add('reveal-cta');
    observer.observe(cta);
  });
}
